import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

import ivan from '@/pages/ivan'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'ivan',
      component: ivan
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js